<!-- Institute of Design and Innovation (email idi@unm.edu). -->

<!-- Manage Appointment webpage -->
<template>
  <div class="pi-scheduler manage-appointment page">
    <header>
      <div class="logo">
        <img src="../assets/osp.png">
      </div>
    </header>

    <div class="scheduler-wrapper">
      <div class="upcoming-appointments" v-if="appointment">
        <div class="upcoming-appointment" v-if="!cancelled">
          <div class="header">
            <h5>{{ appointment.appointmentType.name  }}</h5>
            <span><i class="fal fa-calendar"></i> {{ formatTime(appointment.start, 'MMMM do yyyy \'at\' h:mma') }}</span>
          </div>
          <p>{{ appointment.appointmentType.description }}</p>
          <div class="ql-editor" v-if="appointment.appointmentType.emailConfirmationMessage !== '' && !appointment.cancelled" v-html="appointment.appointmentType.emailConfirmationMessage"></div>
          <div class="app-cancelled" v-if="appointment.cancelled">This appointment has been cancelled</div>
          <div class="actions" v-if="!passed && !appointment.cancelled">
            <a class="shaded red" @click="cancelAppointment(appointment.id)">Cancel</a>
            <a class="shaded black" target="_blank" :href="'/api/appointment/' + appointment.id + '/ics'" style="text-decoration: none;"><i class="fal fa-calendar-plus"></i> Download ics</a>
          </div>
        </div>

        <transition name="fade-up">
        <div class="cancelled-message" v-if="cancelled">
          Your appointment has been cancelled.
        </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { format, isBefore } from 'date-fns'
import { defineComponent } from 'vue'
import { mapGetters } from 'vuex'
import AppointmentService from '../common/appointmentService'
import Appointment from '../models/appointment'
export default defineComponent({
  name: 'ManageAppointment',

  data () {
    return {
      appointment: null as unknown as Appointment,
      cancelled: false
    }
  },

  watch: {
    $route: {
      handler (route) {
        AppointmentService.get(route.params.id).then(res => {
          res.data.start = new Date(res.data.start)
          res.data.end = new Date(res.data.end)
          this.appointment = res.data
        })
      },
      immediate: true
    }
  },

  computed: {
    passed (): boolean {
      return isBefore(this.appointment.start, new Date())
    }
  },

  methods: {
    /**
     * Cancel appointment
     */
    cancelAppointment (appointemntId: number) {
      if (confirm('Are you sure you want to cancel this appointment?')) {
        AppointmentService.cancelAppointment(appointemntId).then(res => {
          this.cancelled = true
        })
      }
    },

    /**
     * Formats the given date in the specified format
     */
    formatTime (date: Date, formatString: string): string {
      return format(date, formatString)
    }
  }
})
</script>
